import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

import { useI18n } from '../i18n/providers/I18nProvider.js'
import { LinkPicker } from '../Picker/LinkPicker.js'

export const LinkFieldPicker = ({
  value,
  openInNewWindow,
  label,
  name,
  onChange,
}: {
  name?: string
  label?: string
  value?: string
  openInNewWindow?: boolean
  onChange: (href: string, openInNewWindow: boolean) => void
}) => {
  const { $t } = useI18n()

  return (
    <div className="space-y-2">
      <LinkPicker
        name={name}
        label={label}
        value={value}
        onChange={newLink => onChange(newLink, openInNewWindow)}
      />
      <FormControl.Toggle
        name="openInNewWindow"
        label={$t({
          id: 'Generics.OpenInNewWindow',
          defaultMessage: 'Open in a new window',
        })}
        checked={openInNewWindow}
        onChange={t => {
          onChange(value, t)
        }}
      />
    </div>
  )
}
